import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Hero from "../components/Hero";
import Marquee from "../components/Marquee";
import Pain from "../components/Pain";
import HowItWorks from "../components/HowItWorks";
import ValueStack from "../components/ValueStack";
import OfferCards from "../components/OfferCards";
import Testimonials from "../components/Testimonials";
import FAQ from "../components/FAQ";
import FinalCTA from "../components/FinalCTA";

export default function HomePage() {
  return (
    <div className="bg-grain min-h-screen" data-testid="home-page">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Pain />
        <HowItWorks />
        <ValueStack />
        <OfferCards />
        <Testimonials />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}
